export default "__VITE_ASSET__CV4xaY0e__"